import {Component, Input} from '@angular/core';
import {AusreisserListe} from 'shared/dtos/cockpit-kontrolle/einfluss-von-extremwerten-m1';
import {MitarbeiterBase} from 'shared/dtos/mitarbeiterBase';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-ausreisser-liste',
  templateUrl: './ausreisser-liste.component.html',
  styleUrls: [
    './ausreisser-liste.component.scss',
    '../../../../cockpit-shared/contents/cockpit-styles.scss'
  ],
  standalone: false
})
export class AusreisserListeComponent extends CurrentLocaleComponent {
  @Input() data: AusreisserListe;
  @Input() mitarbeiters: MitarbeiterBase[];

  constructor(protected readonly translate: TranslateService) {
    super(translate);
  }
}
